export default "__VITE_ASSET__DNUC98f$__"